"use client";

import type { HeaderMobileMenuFooterProps } from "./types/header-mobile-menu-footer.types";
import { headerMobileMenuFooterStyles } from "./styles/header-mobile-menu-footer.styles";

export const HeaderMobileMenuFooter: React.FC<HeaderMobileMenuFooterProps> = (props) => {
  const { children, className, ...rest } = props;
  return (
    <div className={headerMobileMenuFooterStyles({ className })} {...rest}>
      {children}
    </div>
  );
};

HeaderMobileMenuFooter.displayName = "HeaderMobileMenuFooter";
